<template>
  <v-row>
    <!-- kitchen sink -->
    <v-col cols="12">
      <app-card-code :title="`${$t('menu.contratos')} / ${$t('menu.hotels')}`">
        <ContrateHotelList />
      </app-card-code>
    </v-col>
  </v-row>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

import ContrateHotelList from './tablas/ContrateHotelList.vue'

export default {
  components: {
    AppCardCode,
    ContrateHotelList,
  },
}
</script>
